module.exports = __webpack_public_path__ + "img/pleisure_bodyimage05-2.6518eecb.jpg";